export type MuseumCharItem = {
  isOld: number
  id: number
  title: string | null
  articleSlug: string
  bodyJson: string | null
  image: ImageObject | null
  articleCommentCount: number
  museum: string | null
  toMuseum: string | null
  toDetail: string | null
  toDetailPreview: string | null
  toComment: string | null
}

export const useStoreMuseumChar = defineStore('museumChar', {
  state: () => ({}),
  actions: {
    async fetchCharaList(kijidasConfig: any, awardSlug: string, year: number, catId, slug = null): Promise<MuseumCharItem[] | null> {
      const storeIndex = useStoreIndex()
      const storeArticleList = useStoreArticleList()

      const query = {}
      if (catId) {
        query['category'] = catId
      }
      if (slug) {
        query['article_slug'] = slug
      }

      const resCharList = await storeArticleList.fetchList('awardMain', {
        config: { articleTypeSlug: awardSlug },
        query: query,
      })
      if (resCharList.code !== 200000) {
        return null
      }

      if (!resCharList.data?.articles?.length) {
        return null
      }

      const charItems = resCharList.data?.articles as Article[]
      let items = []
      for (let i = 0; i < charItems.length; i++) {
        const item = charItems[i]
        const newItem = {} as MuseumCharItem
        if (item.is_old === 0) {
          newItem.isOld = 0
        } else {
          newItem.isOld = 1
        }
        newItem.id = item.id
        newItem.title = item.title.replace(/<!--.+?-->/, '')
        newItem.articleSlug = item.article_slug
        newItem.bodyJson = item.body_json
        newItem.image = storeIndex.getImgInfoByEyeCatch(item.eye_catch_image_object, null)
        if (year <= 2019) {
        //  旧コンテンツは 投票数は point を使う
          newItem.articleCommentCount = item.point
        } else {
          newItem.articleCommentCount = item.article_comment_count
        }
        if (item.relations.length) {
          newItem.museum = item.relations[0].article.title
          newItem.toMuseum = `/museum/${item.relations[0].article.article_slug}`
        } else {
          newItem.museum = ''
        }
        newItem.toDetail = `/${awardSlug}/${year}/${newItem.articleSlug}`
        newItem.toDetailPreview = `/preview/${awardSlug}/${year}/${newItem.articleSlug}/`
        newItem.toComment = `/${awardSlug}/${year}/${newItem.articleSlug}/comment`
        items.push(newItem)
      }
      //  旧コンテンツはpointでソート
      if (year <= 2019) {
        items = items.sort((a, b) => {
          return b.articleCommentCount - a.articleCommentCount
        })
      }

      return items
    },
  },
})
